import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../../auth/AuthProvider';
import { structureApi, type Structure, type StructureKind } from './structureApi';

export function useStructure(kind: StructureKind, parentId: number, enabled: boolean) {
  const client = useQueryClient(), { refresh } = useAuth();
  const key = ['creation-structure', kind, parentId];
  const query = useQuery({ queryKey: key, queryFn: () => structureApi.get(kind, parentId), enabled: enabled && !!parentId, refetchInterval: 30000 });
  const saved = async (data: Structure) => {
    client.setQueryData(key, data);
    await refresh();
    await client.invalidateQueries({ predicate: q => ['regulation', 'assets', 'regulation-assets', 'access-projects'].includes(String(q.queryKey[0])) });
  };
  const order = useMutation({ mutationFn: (ids: number[]) => {
    if (!query.data) throw new Error('Дождитесь загрузки списка.');
    return structureApi.reorder(kind, parentId, ids, query.data.revision);
  }, onSuccess: saved, onError: () => { void query.refetch(); } });
  return { query, order, saved };
}
